import { render, staticRenderFns } from "./EventConfigEdit.vue?vue&type=template&id=b2821798&scoped=true"
import script from "./EventConfigEdit.vue?vue&type=script&lang=js"
export * from "./EventConfigEdit.vue?vue&type=script&lang=js"
import style0 from "./EventConfigEdit.vue?vue&type=style&index=0&id=b2821798&prod&lang=scss"
import style1 from "./EventConfigEdit.vue?vue&type=style&index=1&id=b2821798&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2821798",
  null
  
)

export default component.exports